import { RiskRanges } from "../ranges";
import { Risk, Sex } from "../units";

function rangesFor({ sex }: { sex: Sex }): RiskRanges<"mmol/L"> {
  if (sex === Sex.Male) {
    return new RiskRanges("mmol/L", [
      { from: 2.0, to: Infinity, risk: Risk.Risk, label: "high" },
      { from: 1.4, to: 2.0, risk: Risk.Optimal, label: "optimal" },
      { from: 1.0, to: 1.4, risk: Risk.Normal, label: "normal" },
      { from: 0, to: 1.0, risk: Risk.Risk, label: "low" },
    ]);
  }

  if (sex === Sex.Female) {
    return new RiskRanges("mmol/L", [
      { from: 2.5, to: Infinity, risk: Risk.Risk, label: "high" },
      { from: 1.8, to: 2.5, risk: Risk.Optimal, label: "optimal" },
      { from: 1.2, to: 1.8, risk: Risk.Normal, label: "normal" },
      { from: 0, to: 1.2, risk: Risk.Risk, label: "low" },
    ]);
  }

  return new RiskRanges("mmol/L", []);
}

export const HDL = {
  rangesFor,
};
